<template>
  <div class="hamburger">
    <div class="bar" />
    <div class="bar" />
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.hamburger {
  @apply flex flex-col justify-center items-center h-full w-full gap-0.5;
  transition: background-color .25s ease-in-out;

  .hover {
    .bar {
      @include mediasmReverse {
        @apply bg-red;
      }
    }
  }
}

.bar {
  height: 2px;
  background-color: currentColor;
  transition: all 0.35s;

  &:nth-child(1) {
    @apply w-full mb-1.5;

    .active & {
      transform: translateY(calc(250%)) rotate(45deg);
    }
  }

  &:nth-child(2) {
    @apply w-full mb-1.5;
    .active & {
      transform: translateY(calc(-250%)) rotate(-45deg);
    }
  }

}
</style>
